import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';

/**
 * Fusionne plusieurs PDF (devis + CV des collaborateurs) en un seul document
 * client final (CDC §8.4 / §9.3). Fusion réalisée entièrement côté navigateur
 * avec pdf-lib — aucun appel backend nécessaire puisque le PDF du devis est
 * déjà généré côté front par DevisPdfService (pdfmake).
 */
@Injectable({ providedIn: 'root' })
export class DevisDocumentMergeService {

  /**
   * @param pdfBuffers PDF à fusionner dans l'ordre voulu : le premier élément
   *                   doit être le PDF du devis, les suivants les CV des
   *                   collaborateurs (déjà triés par ordre_affichage).
   */
  async merge(pdfBuffers: (Uint8Array | ArrayBuffer)[]): Promise<Uint8Array> {

    const mergedPdf = await PDFDocument.create();

    for (const buffer of pdfBuffers) {

      const pdf = await PDFDocument.load(buffer, { ignoreEncryption: true });

      const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());

      pages.forEach(page => mergedPdf.addPage(page));
    }

    return mergedPdf.save();
  }
}